/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Settings_Validation_FailedInputs */

const vi_einvoice_settings_validation_failed = /** @type {(inputs: Einvoice_Settings_Validation_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cài đặt không hợp lệ. Vui lòng kiểm tra các trường.`)
};

/**

* @param {Einvoice_Settings_Validation_FailedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_settings_validation_failed = /** @type {((inputs?: Einvoice_Settings_Validation_FailedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Settings_Validation_FailedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_settings_validation_failed(inputs)
});